<template>
  <v-expansion-panel class="idcs-main-back">
    <v-expansion-panel-header v-slot="{ open }">
      <v-layout align-center wrap fluid>
        <v-flex xs12 sm4 md3 lg2 xl2>
          <v-subheader>
            <v-icon class="mr-2" :color="labelGeneralColor">fa-heartbeat</v-icon>
            <span>{{ $t("card.profile") }}</span>
          </v-subheader>
        </v-flex>
        <v-flex xs12 sm6 md5 lg6 xl6>
          <div v-if="!open">
            <v-icon size="32" class>mdi-credit-card-clock</v-icon>
            <v-icon small class="mx-6">fa-arrow-right</v-icon>
            <span class="text-uppercase mr-4">{{ $t("card.validto") }}</span>
            <span class="title">{{ lastValid | dt-time }}</span>
          </div>
        </v-flex>
        <v-flex xs12 sm6 md2 lg2 xl2>
          <v-chip
            v-if="labelGeneralStatus"
            :color="labelGeneralColor"
            class="text-uppercase"
          >{{ $t(labelGeneralStatus) }}</v-chip>
        </v-flex>
        <v-flex xs12 sm6 md2 lg2 xl2 class="text-right">
          <v-btn
            @click="d_block = true"
            class="mr-5"
            v-if="$store.getters.test('fstat.w')"
          >{{ $t("button.block") }}</v-btn>
        </v-flex>
      </v-layout>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-layout align-center fluid wrap class="main-card-panel idcs-data-back">
        <v-flex xs12>
          <!--TODO updating valid from more 3-4 year  !-->
          <v-slider
            v-model="sliderPos"
            readonly
            :thumb-size="32"
            thumb-label="always"
            :min="0"
            :color="labelGeneralColor"
            track-color="light-blue accent-1"
            height="20px"
            :max="sliderMax"
            :messages="labelValid"
          >
            <template v-slot:thumb-label>
              <v-icon color="white">mdi-credit-card-clock</v-icon>
            </template>
            <template v-slot:append>
              <div class="slider-end-date text-center">
                <v-btn
                  x-small
                  class="text-center"
                  text
                  color="blue"
                  v-if="$store.getters.test('fvalid.w')"
                  @click="d_extend = true"
                >
                  <div>{{ $t("card.validto") }}</div>
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <div class="valid-end-date title">{{ lastValid | dt-only }}</div>
                <div class="valid-end-time subtitle-2">{{ lastValid | time-only }}</div>
              </div>
            </template>
            <template v-slot:prepend>
              <div class="slider-start-date text-center grey--text">
                <div class="caption">{{ $t("card.validfrom") }}</div>
                <div class="subtitle-2">{{ startValid | dt-only }}</div>
              </div>
            </template>
            <template v-slot:message="{ message }">
              <div class="hidden-xs-only slider-remain-message">
                <span class="mr-2">{{ $t("card.until") }}</span>
                <span>{{ message }}</span>
              </div>
            </template>
          </v-slider>
        </v-flex>
      </v-layout>
    </v-expansion-panel-content>
    <v-dialog persistent v-model="d_extend" width="500">
      <v-card class="idcs-dialog-back">
        <v-card-title>
          <span>{{ $t("title.extend_card") }}</span>
          <v-spacer></v-spacer>
          <v-btn color="error" icon @click="d_extend = false">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-date-picker
            v-model="newValidDate"
            :min="$moment().format('YYYY-MM-DD')"
            :locale="$i18n.locale"
            year-icon="mdi-pencil"
            full-width
          ></v-date-picker>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue" text @click="updateValid">{{ $t("button.ok") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="d_block" width="340">
      <v-card class="idcs-dialog-back">
        <v-card-title>
          <span>{{ $t("title.status_card") }}</span>
          <v-spacer></v-spacer>
          <v-btn icon color="error" @click="d_block = false">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="idcs-dialog-back">
          <v-select
            v-model="newStatus"
            :items="card_status"
            background-color="yellow lighten-5"
            shaped
            outlined
            :placeholder="$t('field.status')"
            :label="$t('field.status')"
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue" text @click="updateStatus">{{ $t("button.ok") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-expansion-panel>
</template>

<script>
import app from "@/app.js";
export default {
  name: "CardMainPanel",
  props: {
    icard: Object,
    vstart: Object,
    vend: Object,
    trans: Number,
    logs: Number
  },
  data() {
    return {
      d_extend: false,
      d_block: false,
      newValidDate: this.$moment().format("YYYY-MM-DD"),
      newStatus: null,
      startValid: this.vstart,
      lastValid: this.vend,
      sliderMax: 0,
      sliderPos: 0,
      card: { ...this.icard },
      card_status: [
        { text: this.$t("status.1"), value: 1 },
        { text: this.$t("status.2"), value: 2 },
        { text: this.$t("status.100"), value: 100 }
      ],
      activated: null
    };
  },
  watch: {
    icard: {
      handler(v) {
        //console.log("card watched", v);
        this.card = { ...v };
      }
    },
    vstart: {
      handler(v) {
        //console.log("startValid watched", v);
        this.startValid = v;
        this.recalculate();
      }
    },
    vend: {
      handler(v) {
        //console.log("lastValid watched", v);
        this.lastValid = v;
        this.recalculate();
      }
    }
  },
  mounted() {
    this.recalculate();
  },
  computed: {
    labelGeneralStatus() {
      //console.log("status", this.card.status, this.trans, this.logs, this.lastValid);
      if (this.card.status == 1) return "card.status.archived";
      if (this.card.status == 2) return "card.status.blocked";
      //      if (this.card.status != 100) return "card.status.blockedByStatus";
      if (!this.logs && !this.trans) return "card.status.inactive";
      if (!this.trans) return "card.status.awaiting";
      if (this.$moment().isAfter(this.lastValid))
        return "card.status.blockedByValid";
      return false;
      //      return "label.active";
    },
    labelGeneralColor() {
      //console.log("color", this.card.status, this.trans, this.logs, this.lastValid);
      if (this.card.status != 100) return "error";
      if (!this.logs && !this.trans) return "warning";
      if (this.trans == 0) return "orange";
      if (this.$moment().isAfter(this.lastValid)) return "error";
      return "light-blue accent-4";
    },
    labelValid: {
      cache: false,
      get() {
        if (this.$moment().isAfter(this.lastValid))
          return this.$t("card.status.blocked");
        let diff = this.$moment.duration(this.$moment().diff(this.lastValid));
        return diff.locale("ru").humanize();
      }
    },
 /*   compLastValid: {
      cache: false,
      get() {
        try {
          return this.lastValid.diff(this.startValid, "days");
        } catch (e) {
          return 0;
        }
      }
    },
    currentValid: {
      cache: false,
      get() {
        try {
          return this.$moment().diff(this.startValid, "days");
        } catch (e) {
          return 0;
        }
      },
      set() {}
    }*/
  },
  methods: {
    recalculate() {
      try {
        this.sliderMax = this.lastValid.diff(this.startValid, "days");
        //console.log(this.startValid.format("lll"),this.sliderMax,this.lastValid.format("lll"));
        this.sliderPos = this.$moment().diff(this.startValid, "days");
      } catch (e) {
        return 0;
      }
    },
    updateValid() {
      app
        .updateCardValid(
          this.card.id,
          this.$moment(this.newValidDate)
            .endOf("day")
            .valueOf()
        )
        .then(response => {
          let msg = this.$t("msg.valid.fail");
          if (response.count == 1) {
            this.lastValid = this.$moment(this.newValidDate).endOf("day");
            this.recalculate();
            msg = this.$t("msg.valid.ok");
          }
          this.$root.$emit("show_snack", {
            color: response.count != 1,
            msg: msg
          });
          this.d_extend = false;
        })
        .catch(() => {
          this.$root.$emit("show_snack", {
            color: true,
            msg: this.$t("msg.valid.fail")
          });
        });
    },
    updateStatus() {
      app
        .updateCardStatus(this.card.id, this.newStatus)
        .then(response => {
          let msg = this.$t("msg.status.fail");
          if (response.count == 1) {
            msg = this.$t("msg.status.ok");
            this.card.status = this.newStatus;
          }
          this.$root.$emit("show_snack", {
            color: response.count != 1,
            msg: msg
          });
          this.d_block = false;
        })
        .catch(() => {
          this.$root.$emit("show_snack", {
            color: false,
            msg: this.$t("msg.status.fail")
          });
        });
    }
  }
};
</script>

<style scoped>
.main-card-panel {
  padding-top: 50px;
  border: 1px;
  border-color: black;
  border-style: dotted;
  border-radius: 25px;
  color: black;
  padding-bottom: 16px;
}
.slider-start-date {
  width: 130px;
  margin-top: -16px;
}
.slider-end-date {
  width: 160px;
  margin-top: -35px;
}
.slider-remain-message {
  text-align: center;
  font-weight: bold;
}
</style>